export default "/assets/images/awards-img-02-lg.svg?23b8b12076a87d4ac7d731554f517255";